import { type SupportedIntegrationSyncTypes, type SupportedIntegrationTypes } from '#shared/lib/integrations';
import { showError } from '#shared/lib/toast';
import { updateIntegrationSettings } from './updateIntegrationSettings';

export const setupIntegrationSettings = async ({
    syncType,
    type,
    refetch,
}: {
    syncType: SupportedIntegrationSyncTypes;
    type: SupportedIntegrationTypes;
    refetch: VoidFunction;
}): Promise<boolean> =>
    updateIntegrationSettings({
        syncType,
        payload: { system_type: type },
        refetch,
        onError: (error) => {
            showError(
                { label: 'Произошла ошибка при сохранении источника.' },
                error instanceof Error ? error.message : undefined
            );
        },
    });
